import { createIdxOptionsConstructor, createIdxStorageManager, createIdxTransactionManager, createOktaAuthOAuth, mixinIdx } from "@okta/okta-auth-js";
const OptionsConstructor = createIdxOptionsConstructor();
const StorageManager = createIdxStorageManager();
const IdxTransactionManager = createIdxTransactionManager();
const OktaAuthOAuth = createOktaAuthOAuth(StorageManager, OptionsConstructor, IdxTransactionManager);
const OktaAuth = mixinIdx(OktaAuthOAuth);
export { OktaAuth };
